import { Edit } from '@mui/icons-material';
import { IconButton, CircularProgress, Switch } from '@mui/material';

export const userTableHeaders = ({ handleEdit, handleSwitchChange, loadingRowId }) => {
    return [
        {
            id: 'status',
            label: 'Status',
            sort: false,
            render: (row) =>
                row?.id == loadingRowId ? (
                    <CircularProgress />
                ) : (
                    <Switch checked={row?.is_active} onChange={(e) => handleSwitchChange(e, row)} />
                ),
        },
        {
            id: 'name',
            label: 'Name',
            sort: false,
            render: (row) => `${row.first_name} ${row.last_name}`,
        },
        {
            id: 'email',
            label: 'Email',
            sort: false,
        },
        {
            id: 'phone_number',
            label: 'Phone Number',
            sort: false,
        },
        {
            id: 'action',
            label: 'Action',
            sort: false,
            render: (row) => (
                <IconButton onClick={() => handleEdit(row)} sx={{ padding: 0 }}>
                    <Edit fontSize="small" />
                </IconButton>
            ),
        },
    ];
};
